// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import Heading from "../Heading"

const SectionFeaturedOn = ({ section }: any) => {
  const { title, background } = section

  return (
    <Container constrainedToBreakPoint fullWidthOnMobile={false}>
      <Box className="text-center lg:flex lg:items-center lg:justify-center md:px-8 lg:px-4 lg:gap-24 my-8">
        <Heading as="h4" className="whitespace-nowrap mb-4 lg:mb-0">
          {title}
        </Heading>
        <GatsbyImage
          image={background?.Image?.asset?.gatsbyImageData}
          alt={background?.Image?.asset?.altText || "featured on"}
        />
      </Box>
    </Container>
  )
}

export default SectionFeaturedOn
